(ns renolit-roofing-service.layout.sidebar
  (:require
   [clojure.string :as string]
   [dev.gethop.session.re-frame.cognito.action.logout :as cognito.logout]
   [re-frame.core :as rf]
   [renolit-roofing-service.layout.dropdown-menu :as layout.dropdown-menu]
   [renolit-roofing-service.layout.icon :as layout.icon]
   [renolit-roofing-service.localization :refer [t]]
   [renolit-roofing-service.navigation :as nav]
   [renolit-roofing-service.user :as user]
   [renolit-roofing-service.util :as util]
   [renolit-roofing-service.util.interop :as util.interop]
   [renolit-roofing-service.view :as view]))

(rf/reg-event-fx
 ::logout-success
 (fn [{:keys [db]} _]
   {:db (dissoc db :user)
    :dispatch [::nav/push-state [:login]]}))

(rf/reg-event-fx
 ::logout-failure
 (fn [_ [_ reason]]
   {:dispatch [::util/generic-error reason]}))

(defn- is-subpath?
  [parent-path {:keys [data] :as _current-route}]
  (string/starts-with? (str (:name data)) (str parent-path)))

(def ^:const sections-definition
  {:rae [{:img-key :home
          :label-kw [:common/home]
          :view {:name [:home]}
          :is-current?-fn (partial is-subpath? [:home])}
         {:img-key :menu
          :label-kw [:common/projects]
          :view {:name [:project-list]}
          :is-current?-fn (partial is-subpath? [:project])}]
   :installer [{:img-key :home
                :label-kw [:common/home]
                :view {:name [:installer-home]}
                :is-current?-fn (partial is-subpath? [:installer-home])}]
   :laboratory [{:img-key :home
                 :label-kw [:common/home]
                 :view {:name [:laboratory-home]}
                 :is-current?-fn (partial is-subpath? [:laboratory])}]})

(defn- section
  [current-route {:keys [view img-key is-current?-fn] :as _opts}]
  [:a.sidebar__section
   {:href (nav/href (:name view)
                    (:path-params view)
                    (:query-params view))
    :class [(when (and (fn? is-current?-fn)
                       (is-current?-fn current-route))
              "sidebar__section--current")]}
   [layout.icon/icon
    {:key img-key
     :class "sidebar__section-icon"}]])

(defn- sections
  [current-route role]
  [:div.sidebar__sections
   (for [{:keys [img-key] :as section-def} (get sections-definition role)]
     ^{:key (str "sidebar-section__" img-key)}
     [section current-route section-def])])

(defn- bottom-section
  [_]
  [:div.sidebar__bottom-section
   [:button.flat-btn
    {:on-click #(rf/dispatch [::cognito.logout/user-logout {:on-success-evt [::logout-success]
                                                            :on-failure-evt [::logout-failure]}])}
    [layout.icon/icon
     {:key :logout
      :class "sidebar__section-icon"}]]])

(defn- sidebar
  []
  (let [current-route (rf/subscribe [::view/current-route])
        user (rf/subscribe [::user/user-data])]
    (fn []
      (when (and @current-route @user)
        [:aside.sidebar
         [:a.sidebar__top-logo {:href (nav/href [:home])}
          [:h1 "RENOLIT"]
          [:h3 "Roofing"]]
         [sections @current-route (:role @user)]
         [bottom-section @current-route]]))))

(defn- mobile-close-component
  [opts _args]
  [:button (merge (dissoc opts :className)
                  {:class [(:className opts)
                           "hamburger-menu__close"]})
   [layout.icon/icon
    {:key :close}]])

(defn- mobile-section-component
  [opts {:keys [view img-key label-kw is-current?-fn current-route]}]
  [:button (merge (dissoc opts :className)
                  {:href (nav/href (:name view)
                                   (:path-params view)
                                   (:query-params view))
                   :class [(:className opts)
                           "hamburger-menu__item"
                           (when (and (fn? is-current?-fn)
                                      (is-current?-fn current-route))
                             "hamburger-menu__item--current")]})
   [layout.icon/icon
    {:key img-key}]
   [:span (t label-kw)]])

(defn- mobile-sections
  [current-route role]
  [:<>
   (for [{:keys [img-key] :as section-def} (get sections-definition role)]
     ^{:key (str "hamburger-menu-section__" img-key)}
     [:> layout.dropdown-menu/menu-item
      {:component mobile-section-component
       :args (util.interop/->js-interop-data-envelope
              (assoc section-def :current-route current-route))
       :label (str img-key)
       :onClick (fn [_] true)}])])

(defn- mobile-profile-component
  [opts {:keys [current-route]}]
  [:button (merge (dissoc opts :className)
                  {:class [(:className opts)
                           "hamburger-menu__item"
                           (when (is-subpath? :user current-route)
                             "hamburger-menu__item--current")]
                   ;; TODO fix the routes here
                   ;; :href (nav/href [:user :profile])
                   })
   [layout.icon/icon
    {:key :profile}]
   [:span (t [:common/profile])]])

(defn- mobile-logout-component
  [opts _args]
  [:button (merge (dissoc opts :className)
                  {:class [(:className opts)
                           "flat-btn"
                           "hamburger-menu__item"]})
   [layout.icon/icon
    {:key :logout}]
   [:span (t [:common/close-session])]])

(defn- mobile-bottom-section
  [current-route]
  [:<>
   #_[layout.dropdown-menu/item-separator]
   [:> layout.dropdown-menu/menu-item
    {:component mobile-profile-component
     :args (util.interop/->js-interop-data-envelope
            {:current-route current-route})
     :label "profile"
     :onClick (fn [_] true)}]
   [:> layout.dropdown-menu/menu-item
    {:component mobile-logout-component
     :label (t [:common/close-session])
     :onClick (fn [_]
                (rf/dispatch [::cognito.logout/user-logout
                              {:on-success-evt [::logout-success]
                               :on-failure-evt [::logout-failure]}])
                true)}]])

(defn hamburger-menu-items
  []
  (let [current-route (rf/subscribe [::view/current-route])
        user (rf/subscribe [::user/user-data])]
    (fn []
      [:<>
       [:> layout.dropdown-menu/menu-item
        {:component mobile-close-component
         :label "close"
         :onClick (fn [_] true)}]
       [mobile-sections @current-route (:role @user)]
       [mobile-bottom-section @current-route]])))

(defn main
  []
  [sidebar])
